export enum PhoneUpdateFlowStep {
  Warning,
  EnterCurrentPhone,
  EnterPin,
  FaceScan,
  EnterNewPhone,
  Done
}
